import { useState } from "react";

interface ClockOutConfirmModalProps {
  employeeName: string;
  onConfirm: (notes: string) => void;
  onCancel: () => void;
}

export function ClockOutConfirmModal({
  employeeName,
  onConfirm,
  onCancel,
}: ClockOutConfirmModalProps) {
  const [notes, setNotes] = useState("");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" role="dialog" aria-modal="true" aria-labelledby="clock-out-modal-title">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        <h2 id="clock-out-modal-title" className="text-lg font-semibold text-gray-900 mb-2">
          Clock out {employeeName}?
        </h2>
        <p className="text-sm text-gray-600 mb-4">
          This will end the active session. You can add an optional note.
        </p>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Note (optional)</label>
          <input
            type="text"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="e.g. Manager override"
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#FD7657] focus:border-[#FD7657]"
          />
        </div>
        <div className="flex gap-3 justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(notes.trim())}
            className="px-4 py-2 rounded-lg text-sm font-semibold text-white bg-[#dc2626] hover:bg-[#b91c1c] transition-colors"
          >
            Clock out
          </button>
        </div>
      </div>
    </div>
  );
}
